export default "__VITE_ASSET__Dqp0L95l__"